import { createFileRoute } from '@tanstack/react-router';
import { CardPage } from '../components/pages/CardPage/CardPage';

export const Route = createFileRoute('/account/cards_/$cardId')({
  component: CardPage,
});
